// data-turbo-confirm asks with this dialog instead of the browser's confirm():
// some browsers (an embedded one, a page with dialogs turned off) never show
// confirm() and quietly answer "no", so the button just does nothing.
// Resolves true for the confirming button, false for Cancel, Escape or a click
// outside it.
import { Turbo } from "@hotwired/turbo-rails";

function confirmDialog(message, element, submitter) {
  return new Promise((resolve) => {
    const dialog = document.createElement("dialog");
    dialog.className = "m-auto p-0 bg-transparent backdrop:bg-black/70 w-[min(28rem,calc(100vw-2rem))]";
    dialog.innerHTML = `
      <form method="dialog" class="comic-panel bg-gray-800 p-4 text-gray-100">
        <p class="text-sm leading-relaxed whitespace-pre-line"></p>
        <div class="flex justify-end gap-2 mt-4">
          <button value="cancel" class="comic-button text-xs px-2.5 py-1 bg-gray-700 hover:bg-gray-600 text-gray-100">Cancel</button>
          <button value="ok" class="comic-button text-xs px-2.5 py-1 bg-yellow-400 hover:bg-yellow-300 text-gray-900" autofocus></button>
        </div>
      </form>`;
    dialog.querySelector("p").textContent = message;
    // The confirming button says what it does: the clicked button's label, else OK.
    const label = (submitter || element)?.textContent?.trim();
    dialog.querySelector('button[value="ok"]').textContent = label && label.length <= 40 ? label : "OK";
    dialog.addEventListener("click", (event) => { if (event.target === dialog) dialog.close("cancel") });
    dialog.addEventListener("close", () => {
      resolve(dialog.returnValue === "ok");
      dialog.remove();
    });
    document.body.appendChild(dialog);
    dialog.showModal();
  });
}

Turbo.setConfirmMethod(confirmDialog);
